import { sha256Text } from '../quote-engine/canonical-json';

/**
 * The longest entity id the backend media routes accept. printableId in
 * routes/trusted-images.js, safeEntityId in services/trusted-image-derivative.ts,
 * normaliseEntityId in services/trusted-video-proxy.ts and both store-identity
 * readers in routes/media.js refuse more than 200 characters or any control
 * character, with a 400.
 */
export const MAX_SERVER_MEDIA_ENTITY_ID_LENGTH = 200;

/**
 * The id a stored image or video proxy is recorded under on the server.
 *
 * Import Projects names a file `<job folder>::<relative path>`, which passes 200
 * characters for a long RJ Bird folder and a deep path, and a refused id stopped
 * the whole project save on every retry. An id the routes accept is sent
 * exactly as it is. Any other is replaced by a hash of itself, so the same file
 * always gets the same stored identity. Nothing reads this id back to find the
 * photo or video: the browser keeps the s3Key and file metadata id it is given.
 */
export function serverMediaEntityId(id: unknown): string {
    const value = String(id ?? '').trim();
    if (!value) return value;
    if (value.length <= MAX_SERVER_MEDIA_ENTITY_ID_LENGTH && !/[\u0000-\u001f\u007f]/.test(value)) return value;
    return `qm-long-id:${sha256Text(value)}`;
}
